import { sample } from 'effector';
import { resetScreenEvent } from '@nx-frontend/shared/store/screens-store/reset-screen-event';
import { ScreenType } from '@nx-frontend/shared/types';
import { $controlBarState, CustomizerControlbarState, navigateAnimationIsActiveEvent } from './controlbar-store';

interface ValidateResetStoreProps {
  screen: CustomizerControlbarState;
  resetScreens: {
    fromScreenType: ScreenType;
    dontResetScreenTypes: ScreenType[];
  }[];
}

const validateResetStore = ({ screen, resetScreens }: ValidateResetStoreProps): boolean => {
  if (!screen.animationIsActive) {
    let reset = false;
    resetScreens.forEach((resetScreen) => {
      reset =
        screen.history[0] != null &&
        screen.previousScreen != null &&
        screen.history[0].type !== screen.previousScreen.type &&
        screen.previousScreen.type === resetScreen.fromScreenType &&
        !resetScreen.dontResetScreenTypes.includes(screen.history[0].type);
    });
    return reset || screen.history.length <= 1;
  }
  return false;
};

export const resetScreenStore = () => {
  sample({
    source: $controlBarState,
    clock: navigateAnimationIsActiveEvent,
    filter: (screen: CustomizerControlbarState) => {
      return validateResetStore({
        screen,
        resetScreens: [
          {
            fromScreenType: ScreenType.BLOCK_INFO,
            dontResetScreenTypes: [ScreenType.ADD_IMAGE, ScreenType.ADD_LINK, ScreenType.NIMBUS_PAGE],
          },
          {
            fromScreenType: ScreenType.BLOCK_EMBED,
            dontResetScreenTypes: [ScreenType.CONFIRM],
          },
        ],
      });
    },
    fn: () => null,
    target: resetScreenEvent,
  });
};
